import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowInboundIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 11C22.45 11 22 11.45 22 12V20.56C22 21.36 21.35 22 20.56 22H3.44C2.64 22 2 21.35 2 20.56V3.44C2 2.64 2.65 2 3.44 2H12C12.55 2 13 1.55 13 1C13 0.45 12.55 0 12 0H3.44C1.54 0 0 1.54 0 3.44V20.55C0 22.45 1.54 23.99 3.44 23.99H20.55C22.45 23.99 23.99 22.45 23.99 20.55V11.99C23.99 11.44 23.54 10.99 22.99 10.99L23 11Z"
        fill={color}
      />
      <path
        d="M8.10998 8.33C8.10998 7.78 7.65999 7.33 7.10999 7.33C6.55999 7.33 6.10999 7.78 6.10999 8.33V16.89C6.10999 17.44 6.55999 17.89 7.10999 17.89H15.67C16.22 17.89 16.67 17.44 16.67 16.89C16.67 16.34 16.22 15.89 15.67 15.89H9.52998L23.71 1.71C24.1 1.32 24.1 0.69 23.71 0.3C23.32 -0.0900003 22.69 -0.0900003 22.3 0.3L8.11999 14.48V8.34L8.10998 8.33Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowInboundIcon.displayName = 'ArrowInboundIcon';
